import { ref, onMounted, onBeforeUnmount } from 'vue';

export const readDashboardViewport = browserWindow => {
  const viewport = browserWindow.visualViewport;
  // Keep pinch zoom under the browser's control rather than relaying out the app.
  const useVisualViewport = viewport && viewport.scale === 1;
  return {
    height: `${useVisualViewport ? viewport.height : browserWindow.innerHeight}px`,
    top: `${useVisualViewport ? Math.max(0, viewport.offsetTop) : 0}px`,
  };
};

export const useDashboardViewport = () => {
  const viewportStyle = ref(readDashboardViewport(window));
  const update = () => {
    viewportStyle.value = readDashboardViewport(window);
  };
  const targets = [
    [window, 'resize'],
    [window, 'orientationchange'],
    [window, 'pageshow'],
    [document, 'visibilitychange'],
    [window.visualViewport, 'resize'],
    [window.visualViewport, 'scroll'],
  ].filter(([target]) => target);
  onMounted(() => {
    document.documentElement.classList.add('talkvia-dashboard-viewport');
    update();
    targets.forEach(([target, event]) =>
      target.addEventListener(event, update)
    );
  });
  onBeforeUnmount(() => {
    document.documentElement.classList.remove('talkvia-dashboard-viewport');
    targets.forEach(([target, event]) =>
      target.removeEventListener(event, update)
    );
  });
  return viewportStyle;
};
